(function () {
  'use strict';

  var SESSION_IDLE_MINUTES = 10;
  var SESSION_CACHE_KEY = 'nbnw:geo-country:v1';

  var script = document.currentScript;
  var location = window.location;
  var shopify = window.Shopify || {};
  if (location.protocol !== 'https:' ||
      !['norblacknorwhite.in', 'www.norblacknorwhite.in'].includes(location.hostname)) return;
  if (shopify.designMode || shopify.visualPreviewMode || shopify.previewMode ||
      (shopify.theme && shopify.theme.role && shopify.theme.role !== 'main')) return;
  if (window.self !== window.top || document.getElementById('preview-bar-iframe')) return;

  var query = new URLSearchParams(location.search);
  if (['preview_theme_id', 'preview_key', 'preview_token', '_bt', '_sc', '_fd']
      .some(function (key) { return query.has(key); })) return;

  var path;
  try { path = decodeURIComponent(location.pathname); } catch (_) { return; }
  if (/^\/(?:[a-z]{2,3}(?:-[a-z]{2})?\/)?account(?:\/|$)/i.test(path)) return;
  var accountUrl = script && script.getAttribute('data-account-url');
  if (accountUrl) {
    var accountPath = new URL(accountUrl, location.href).pathname.replace(/\/$/, '');
    if (path === accountPath || path.indexOf(accountPath + '/') === 0) return;
  }

  var countries = new Set(('AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW').split(' '));

  function saveCountry(country) {
    try {
      window.sessionStorage.setItem(SESSION_CACHE_KEY, JSON.stringify({
        country_code: country, lastSeen: Date.now()
      }));
    } catch (_) { /* Storage may be blocked; routing still works. */ }
  }

  function route(country) {
    if (country === 'IN') return;
    var destination = new URL(location.href);
    destination.hostname = 'norblacknorwhite.com';
    destination.port = '';
    location.replace(destination.href);
  }

  // Each eligible page load extends this tab's cache by another idle window.
  // VPN changes are checked only after that window expires (or a new session).
  try {
    var cached = JSON.parse(window.sessionStorage.getItem(SESSION_CACHE_KEY));
    var age = cached ? Date.now() - cached.lastSeen : -1;
    if (cached && countries.has(cached.country_code) &&
        Number.isFinite(cached.lastSeen) && age >= 0 &&
        age < SESSION_IDLE_MINUTES * 60 * 1000) {
      saveCountry(cached.country_code);
      route(cached.country_code);
      return;
    }
    window.sessionStorage.removeItem(SESSION_CACHE_KEY);
  } catch (_) { /* Ignore corrupt or unavailable session storage. */ }

  if (!window.fetch || !window.AbortController) return;
  var controller = new AbortController();
  var timer = setTimeout(function () { controller.abort(); }, 5000);

  fetch('https://nbnw-geo.shop-e1a.workers.dev/country', {
    method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store',
    referrerPolicy: 'no-referrer', signal: controller.signal
  }).then(function (response) {
    if (!response.ok) throw new Error('Country unavailable');
    return response.json();
  }).then(function (data) {
    if (controller.signal.aborted || !data || !countries.has(data.country_code)) return;
    saveCountry(data.country_code);
    route(data.country_code);
  }).catch(function () {
    // Fail open: an unavailable service must not prevent shopping.
  }).finally(function () { clearTimeout(timer); });
})();
